export default {
  'menu.welcome': 'Bienvenido',
  'menu.home': 'Inicio',
  'menu.admin': 'Admin',
  'menu.login': 'Authenticarse',
  'menu.register': 'Registrarse',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Análysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Lugar de Trabajo',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulario',
  'menu.list': 'Lista',
  'menu.profile': 'Perfil',
  'menu.result': 'Resultado',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparador',
  'menu.account': 'Cuenta',
  'menu.account.logout': 'Salir',
  'menu.exception.not-permission.description':
    'Lo sentimos, no está autorizado a acceder a esta página.',
  'menu.embedTemplate': 'Plantilla Embebida',

  // BEGIN :: Side Menu Translations
  'menu.options': 'Opciones',
  'menu.processes': 'Procesos',
  'menu.processes.details': 'Detalles',
  'menu.processes.actions': 'Acciones',
  'menu.processes.start': 'Iniciar Solicitud',
  'menu.launchpad': 'Launchpad',
  'menu.tasks': 'Tareas',
  'menu.tasks.tasks': 'Tareas',
  'menu.tasks.myDay': 'Mi Dia',
  'menu.tasks.favorites': 'Favoritos',
  'menu.tasks.planned': 'Planeado',
  'menu.tasks.overdue': 'Vencidas',
  'menu.tasks.miscellaneous': 'Tareas Varias',
  'menu.applications': 'Solicitudes',
  'menu.applications.details': 'Detalles de Solicitud',
  'menu.applications.bulkDetails': 'Detalles de Carga Masiva',
  'menu.applications.continue': 'Continuar',
  'menu.reports': 'Reportes',
  'menu.apps': 'Apps',
  'menu.apps.builder': 'App Builder',
  'menu.agents': 'Agentes',
  'menu.reports.details': 'Detalles de reporte',
  'menu.agents.details': 'Detalles de agente',
  'menu.administration': 'Administración',
  'menu.connections': 'Conexiones',
  'menu.connections.api': 'Conexiones API',
  'menu.connections.database': 'Conexiones Bases de datos',
  'menu.connections.queries': 'Consultas Bases de datos',
  'menu.connections.callback': 'Devolver Llamada',
  'menu.entities': 'Entidades',
  'menu.entities.details': 'Detalles',
  'menu.entities.manage-entities': 'Administrar Entidades',
  'menu.entities.byGroup': 'Por Grupo',
  'menu.entities.groups': 'Grupos de Entidades',
  'menu.entities.entity-builder': 'Entity Builder',
  'menu.configuration': 'Configuración',
  'menu.configuration.users': 'Usuarios',
  'menu.configuration.digital-certificates': 'Certificados Digitales',
  'menu.configuration.users-groups': 'Grupos de Usuarios',
  'menu.configuration.process-group': 'Grupos de Procesos',
  'menu.configuration.positions': 'Puestos',
  'menu.configuration.media': 'Media',
  'menu.configuration.media-categories': 'Categorías de Media',
  'menu.configuration.approvers': 'Aprobadores',
  'menu.configuration.approvers.userGroup': 'Por grupos',
  'menu.configuration.approvers.groupAndPosition': 'Por grupo y puesto',
  'menu.configuration.approvers.entity': 'Por entidad',
  'menu.configuration.approvers.entityAndUserGroup': 'Por entidad y grupo',
  'menu.configuration.approvers.entityAndPosition': 'Por entidad y puesto',
  'menu.configuration.approvers.globalUserGroupAndArea': 'Por grupo y área',
  'menu.configuration.approvers.globalEntityAndArea': 'Por entidad y área',
  'menu.configuration.email-formats': 'Formatos de Correos',
  'menu.configuration.environments': 'Entornos',
  'menu.configuration.process-portal': 'Portal de Procesos',
  'menu.configuration.reports-tokens': 'Tokens de Reportes',
  'menu.configuration.reports': 'Reportes',
  'menu.configuration.reports-groups': 'Grupo de Reportes',
  'menu.configuration.aiConsumptions': 'Consumos de IA',
  'menu.configuration.traces': 'Trazas',
  'menu.configuration.accessLog': 'Registros de Acceso',
  'menu.configuration.delegations': 'Delegaciones',
  'menu.configuration.delegations.items': 'Items',
  'menu.configuration.delegations.items.delegatedTasks': 'Tareas Delegadas',
  'menu.configuration.areas': 'Áreas',
  'menu.configuration.custom-list-groups': 'Grupos de Listas',
  'menu.configuration.ai-agent-teams': 'Equipos de Agentes IA',
  'menu.configuration.ai-skill-groups': 'Grupos de Skills',
  'menu.configuration.dynamic-entity-groups': 'Grupo de Entidades Dinámicas',
  'menu.configuration.connection-group': 'Grupos de Conexiones',
  'menu.configuration.servers': 'Servidores',
  'menu.configuration.power-bi-server': 'Power BI',
  'menu.configuration.shortenedUrl': 'URLs Abreviadas',
  'menu.configuration.sequence': 'Secuencias',
  'menu.configuration.administration': 'Administración',
  'menu.configuration.email-traces': 'Trazas Correo',
  'menu.configuration.teams-message-traces': 'Trazas Teams',
  'menu.configuration.sms-message-traces': 'Trazas SMS',
  'menu.configuration.extra-user-fields': 'Campos Extra Usuario',
  'menu.configuration.user-devices': 'Dispositivos',
  'menu.configuration.notificationTemplates': 'Plantillas de Notificaciones',
  'menu.processes.config': 'Configurar Proceso',
  'menu.connections.groups': 'Grupos',
  'menu.connections.connections': 'Conexiones',
  'menu.lists': 'Listas',
  'menu.lists.groups': 'Grupos',
  'menu.lists.byGroup': 'Por Grupo',
  'menu.lists.details': 'Detalles',
  'menu.user-management': 'Gestión de Usuarios',
  'menu.media': 'Media',
  'menu.mediaAssets': 'Recursos Multimedia',
  'menu.lists-dynamic-entities': 'Listas y Entidades Dinámicas',
  'menu.integration-connections': 'Integración y Conexiones',
  'menu.check-auditory': 'Seguimiento y Auditoría',
  'menu.support': 'Soporte',
  'menu.security': 'Seguridad',
  'menu.organization': 'Organización',
  'menu.configuration.access-policies': 'Políticas de Acceso',
  'menu.configuration.ai-billing': 'AI Billing',
  'menu.channel-commercial-billing': 'Canal Comercial y Billing',
  'menu.configuration.billing-subscriptions': 'Suscripciones',
  'menu.configuration.channel-distributors': 'Distribuidores',
  'menu.configuration.channel-partners': 'Socios',
  'menu.configuration.channel-resellers': 'Revendedores',
  'menu.configurations': 'Configuraciones',
  'menu.filter.result': '({number}) Resultados',
  // END :: Side Menu Translations
};
